module.exports = __webpack_public_path__ + "media/images/coin-e6aaa4f42448e1c5ccf3690d00791f71.gif";